module.exports = __webpack_public_path__ + "img/model6_ug.d981ee4a.jpg";